
export const SET_DISH_DATA = "SET_DISH_DATA";
export const SET_MISC_DISH_DATA = "SET_MISC_DISH_DATA";
export const CLEAR_DISH_DATA = "CLEAR_DISH_DATA";

export const CHANGE_DISH_QUANTITY = "CHANGE_DISH_QUANTITY";
export const CHANGE_INGREDIENT_QUANTITY = "CHANGE_INGREDIENT_QUANTITY";
export const SET_USER_HAS_ALLOWED_ALLERGIC = "SET_USER_HAS_ALLOWED_ALLERGIC";

export const DISH_MODES = {
    CREATE:"create",
    CUSTOMIZE:"customize",
    EXPLORE: "explore"
}